module.exports = __webpack_public_path__ + "static/media/homedelovery.5d267a25.png";